<template>
    <div class="py-12">
        <inertia-link :href="route('kiosk.ai-skills.index')">
            <AtomicButton color="yellow" size="sm">
                {{ t("vue.ai_skills_back") }}
                <template #icon>
                    <BackspaceIcon class="mr-2 h-6 w-6" />
                </template>
            </AtomicButton>
        </inertia-link>

        <h1 class="mt-2 text-2xl font-medium tracking-small text-gray-800">
            {{ t("vue.ai_skills_create") }}
        </h1>

        <SkillForm
            :skill="blank"
            :tools="tools"
            :models="models"
            :submit-url="route('kiosk.ai-skills.store')"
            method="post"
        />
    </div>
</template>

<script lang="ts" setup>
import route from "ziggy-js";
import { BackspaceIcon } from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";
import SkillForm from "./components/SkillForm.vue";
import type {
    IInternalAiSkillFormData,
    IInternalAiSkillToolOption,
} from "@/types/AiChat/IInternalAiSkill";

defineProps<{
    tools: IInternalAiSkillToolOption[];
    models: string[];
}>();

const { t } = useTranslations();

const blank: IInternalAiSkillFormData = {
    slug: "",
    name: "",
    description: "",
    prompt: "",
    tool_recipe: [],
    model: null,
    temperature: null,
    max_output_tokens: null,
    is_active: true,
};
</script>
